import React, { useEffect, useRef, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { useSelector } from "react-redux";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import editChangeValidate, {
  savePreviousState,
  validateChangeAtButton,
} from "../../../../../utils/EditChangeValidate";

export default function AddEditForm({
  submitForm,
  submitFormLoading,
  cancelForm,
  loadedValues = {},
  form = [],
  component,
  setEightHourCost,
  setTenHourCost,
  monthlyCost,
}) {
  const useDidMountEffect = (func, deps = []) => {
    const didMount = useRef(false);
    useEffect(() => {
      if (didMount.current) func();
      else didMount.current = true;
    }, deps);
  };
  const [modified, setModified] = useState(false);
  useDidMountEffect(() => {
    setEightHourCost(Math.ceil((monthlyCost / 26 / 10) * 8));
    setTenHourCost(Math.ceil(monthlyCost / 26));
  }, [monthlyCost]);

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const [prevState, setPrevState] = useState([]);
  const [allowEdit, setAllowEdit] = useState(!loadedValues);

  useEffect(() => {
    if (loadedValues) {
      setPrevState(savePreviousState(form));
    }
  }, []);

  useEffect(() => {
    if (prevState?.length > 0) {
      console.log("pp", prevState);
      const valid = validateChangeAtButton(prevState, form);
      console.log("dd", valid);
      if (valid) setAllowEdit((p) => true);
      else setAllowEdit((p) => false);
    }
  }, [form]);

  return (
    <div className="flex justify-center items-center max-w-3xl mx-auto bg-white dark:bg-dark rounded-lg py-5 mt-5 shadow mb-1">
      <form
        method="POST"
        onSubmit={(event) => submitForm(event)}
        className="w-full  flex flex-col items-center uppercase justify-center"
      >
        {form.map((elem, index) => (
          <div
            key={index}
            className={`flex flex-col p-2 gap-1 w-full max-w-md ${
              elem.hidden ? "hidden" : ""
            }`}
          >
            <label htmlFor={`addOrEdit-${elem.name}`} className="text-xs ">
              {elem.text}
            </label>
            <input
              type={elem.type}
              name={elem.name}
              id={`addOrEdit-${elem.name}`}
              placeholder={`Enter ${elem.text}`}
              required
              className="border-[1px] border-border uppercase dark:bg-dark rounded-md p-1 py-2 text-xs"
              defaultValue={elem.value}
              onChange={(e) => {
                const errorElem = document.getElementById(
                  `${component}-${elem.columnName}`
                );
                errorElem.style.display = "none";
                elem.update(e.target.value.toUpperCase());
              }}
              disabled={elem.disabled ? true : false}
            />
            <p
              id={`${component}-${elem.columnName}`}
              className="hidden w-full h-5 bg-red/5 text-red text-xs"
            ></p>
          </div>
        ))}

        <div className="p-2  w-full max-w-md flex gap-3">
          <button
            type="button"
            className="ring-1 ring-black dark:ring-red uppercase w-full text-xs dark:text-white rounded-md py-2 flex justify-center items-center gap-2"
            disabled={submitFormLoading}
            onClick={cancelForm}
          >
            <p>Cancel</p>
          </button>
          {allowEdit ? (
            <button
              type="submit"
              className="bg-black dark:bg-red w-full uppercase text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              disabled={submitFormLoading}
            >
              <p>Submit</p>
              {submitFormLoading && <CgSpinner className="animate-spin" />}
            </button>
          ) : (
            <button
              disabled
              className="bg-gray dark:bg-rose-400 w-full uppercase text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
            >
              <p>Submit</p>
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
